export async function openFile(file) {
    const isFile = file instanceof File;
    if (!isFile && typeof file !== 'string') {
        throw new Error('A file or URI is required to open a document.');
    }
    const uri = isFile ? URL.createObjectURL(file) : file;
    const opened = window.open(uri, '_blank');
    if (!opened) {
        if (isFile) URL.revokeObjectURL(uri);
        throw new Error('The document window was blocked by the browser.');
    }
    if (isFile) opened.addEventListener('load', () => URL.revokeObjectURL(uri), { once: true });
}
